import { render, staticRenderFns } from "./PanicAlert.vue?vue&type=template&id=44fb4b3d"
import script from "./PanicAlert.vue?vue&type=script&lang=js"
export * from "./PanicAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports